<div class="ion-padding akp">
  <h2><ion-icon name="link-outline"></ion-icon> Kapcsolatok</h2>
  <p class="halvany">
    Kapcsolati kóddal másik intézmény – pl. a könyvelő iroda – olvashatja az itteni adatok egy részét, akkor is, ha egy
    másik rendszeren dolgozik. A kódot add át neki; a beírásával a kapcsolat azonnal él. Minden lekérés naplózódik, és a
    kapcsolat bármikor megszüntethető.
  </p>
  <div class="akp-hiba" *ngIf="hiba">{{ hiba }}</div>

  <ng-container *ngIf="adat">
    <!-- ÚJ KÓD -->
    <section class="akp-kartya">
      <h3>Új kapcsolati kód</h3>
      <div class="akp-hatokorok">
        <label *ngFor="let h of hatokorLista()">
          <input type="checkbox" [(ngModel)]="kert[h]">
          <span><b>{{ hatokorNev(h) }}</b><small>{{ adat.hatokorok[h].leiras }}</small></span>
        </label>
      </div>
      <div class="akp-sor" *ngIf="cegesKell">
        <label>Melyik cég adatai
          <select [(ngModel)]="cegId"><option value="">— válassz céget —</option>
            <option *ngFor="let c of adat.cegek" [value]="c.id">{{ c.nev }}{{ c.adoszam ? ' · ' + c.adoszam : '' }}</option></select></label>
        <small class="halvany" *ngIf="!adat.cegek?.length">Nincs cég a Számla és Kassza / Készletkezelés ügyfelei között.</small>
      </div>
      <div class="akp-sor">
        <label>Érvényes <select [(ngModel)]="ora"><option [ngValue]="0">visszavonásig</option><option [ngValue]="1">1 óráig</option><option [ngValue]="24">1 napig</option><option [ngValue]="72">3 napig</option><option [ngValue]="168">1 hétig</option></select></label>
        <button type="button" class="akp-gomb" (click)="kodKiad()" [disabled]="fut || (cegesKell && !cegId)">Kód generálása</button>
      </div>
      <div class="akp-kod" *ngIf="ujKod">
        <code>{{ ujKod.kod }}</code>
        <button type="button" class="akp-link" (click)="masol(ujKod.kod)">másolás</button>
        <small>Csak most látszik – add át a másik félnek. {{ ujKod.ora ? ujKod.ora + ' óráig' : 'visszavonásig' }}, egyszer használható. Adatkörök: {{ ujKod.hatokorok.map(hatokorNev).join(', ') }}{{ ujKod.ceg ? ' · cég: ' + ujKod.ceg : '' }}.</small>
      </div>
      <div class="akp-fuggo" *ngIf="adat.kodok?.length">
        <b>Még fel nem használt kódok:</b>
        <div *ngFor="let k of adat.kodok">
          {{ k.hatokorok.map(hatokorNev).join(', ') }}{{ k.ugyfel_id ? ' (' + cegNev(k.ugyfel_id) + ')' : '' }} · {{ k.lejar ? 'lejár: ' + (k.lejar | date:'yyyy.MM.dd. HH:mm') : 'visszavonásig' }}{{ k.letrehozta ? ' · ' + k.letrehozta : '' }}
          <button type="button" class="akp-link" (click)="kodTorol(k)" [disabled]="fut">visszavonás</button>
        </div>
      </div>
    </section>

    <!-- KAPCSOLATOK -->
    <section class="akp-kartya">
      <h3>Akik innen olvasnak</h3>
      <div class="halvany" *ngIf="!kiadunk.length">Még nincs ilyen kapcsolat.</div>
      <table class="akp-tabla" *ngIf="kiadunk.length">
        <thead><tr><th>Ki</th><th>Adatkörök</th><th>Állapot</th><th>Utoljára</th><th>Verzió</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let k of kiadunk" [class.ki]="k.allapot !== 'aktiv'">
            <td><b>{{ k.tars_nev || k.tars_intezmeny || 'ismeretlen' }}</b><small *ngIf="k.helyi"> · ez a rendszer</small></td>
            <td>{{ k.hatokorok.map(hatokorNev).join(', ') }}<small *ngIf="k.ceg_nev"> · {{ k.ceg_nev }}</small></td>
            <td>{{ k.allapot === 'aktiv' ? 'él' : 'megszüntetve' }}</td>
            <td>{{ k.utolso_hasznalat ? (k.utolso_hasznalat | date:'yyyy.MM.dd. HH:mm') : '—' }}</td>
            <td>{{ k.tars_verzio || '—' }}<div class="akp-figy" *ngIf="k.figyelmeztetes">{{ k.figyelmeztetes }}</div></td>
            <td><button type="button" class="akp-link piros" *ngIf="k.allapot === 'aktiv'" (click)="visszavon(k)" [disabled]="fut">Megszüntetés</button></td>
          </tr>
        </tbody>
      </table>

      <h3 class="akp-h3">Ahonnan ez az intézmény olvas</h3>
      <div class="halvany" *ngIf="!kerunk.length">Még nincs ilyen kapcsolat (a kódot az ügyfél adatlapján kell beírni: Könyvelés vagy Bér → Ügyfelek).</div>
      <table class="akp-tabla" *ngIf="kerunk.length">
        <thead><tr><th>Adatgazda</th><th>Adatkörök</th><th>Állapot</th><th>Utoljára</th><th>Verzió</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let k of kerunk" [class.ki]="k.allapot !== 'aktiv'">
            <td><b>{{ k.tars_nev || k.tars_intezmeny }}</b><small *ngIf="k.helyi"> · ez a rendszer</small><small *ngIf="!k.helyi && k.tars_url"> · {{ k.tars_url }}</small></td>
            <td>{{ k.hatokorok.map(hatokorNev).join(', ') }}<small *ngIf="k.ceg_nev"> · {{ k.ceg_nev }}</small></td>
            <td>{{ k.allapot === 'aktiv' ? 'él' : 'megszüntetve' }}<div class="akp-hiba kicsi" *ngIf="k.utolso_hiba">{{ k.utolso_hiba }}</div></td>
            <td>{{ k.utolso_hasznalat ? (k.utolso_hasznalat | date:'yyyy.MM.dd. HH:mm') : '—' }}</td>
            <td>{{ k.tars_verzio || '—' }}<div class="akp-figy" *ngIf="k.figyelmeztetes">{{ k.figyelmeztetes }}</div></td>
            <td><button type="button" class="akp-link piros" *ngIf="k.allapot === 'aktiv'" (click)="visszavon(k)" [disabled]="fut">Megszüntetés</button></td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- NAPLÓ -->
    <section class="akp-kartya" *ngIf="adat.naplo?.length">
      <h3>Napló (utolsó 100)</h3>
      <table class="akp-tabla kicsi">
        <thead><tr><th>Idő</th><th>Ki</th><th>Művelet</th><th>Eredmény</th></tr></thead>
        <tbody>
          <tr *ngFor="let n of adat.naplo">
            <td>{{ n.ido | date:'yyyy.MM.dd. HH:mm:ss' }}</td><td>{{ n.tars_nev }}</td><td>{{ n.muvelet }}</td>
            <td [class.piros]="n.eredmeny !== 'ok'">{{ n.eredmeny }}{{ n.hiba ? ' – ' + n.hiba : '' }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- A RENDSZER -->
    <section class="akp-kartya">
      <h3>Ez a rendszer</h3>
      <p class="halvany">A kódok eleje (<code>{{ adat.installacio.elotag }}</code>) azonosítja ezt a rendszert. Hogy egy másik rendszer a kódból
        megtalálja, add meg a nyilvános címét, és jegyezd be a központi címjegyzékbe. Enélkül a másik félnek a címet is meg kell adnia.</p>
      <div class="akp-racs">
        <label>Megjelenő név <input [(ngModel)]="inst.nev" placeholder="pl. Zenit Általános Iskola"></label>
        <label>Nyilvános cím <input [(ngModel)]="inst.url" placeholder="https://erp.iskola.hu" autocapitalize="off"></label>
      </div>
      <div class="akp-sor">
        <button type="button" class="akp-gomb" (click)="instMent()" [disabled]="fut">Mentés</button>
        <button type="button" class="akp-gomb masod" (click)="cimjegyzek()" [disabled]="fut || !adat.installacio.url">Bejegyzés a címjegyzékbe</button>
        <small class="halvany">Verzió: {{ adat.installacio.verzio }} · címjegyzék: {{ adat.installacio.cimjegyzek || 'nincs beállítva' }}
          {{ adat.installacio.cimjegyzek_eredmeny ? '· utolsó bejegyzés: ' + adat.installacio.cimjegyzek_eredmeny : '' }}</small>
      </div>
    </section>
  </ng-container>
</div>
